import { LoadingSpinner } from "@whoosh/design-system/src/components/display/Loader/LoadingSpinner";

import { AuthenticationLayout } from "../AuthenticationLayout";

export const ExistingSessionRedirectLoader = () => (
  <AuthenticationLayout>
    <LoadingSpinner color="grayscale-0" />
  </AuthenticationLayout>
);
